// @core/api/endpoints/resource/create_external_resource.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateExternalResourceRequest,
  ExternalResourceResponse,
} from '../../../types/resource';

const BASE_PATH = '/resource';

/**
 * Register external URL as resource
 * Registers an external URL as a platform resource that can be linked to other entities. Automatically fetches metadata from the URL if not provided.
 */
export async function CreateExternalResource(
  data: CreateExternalResourceRequest,
  options?: RequestOptions
): Promise<ExternalResourceResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/resources/external`;
  const requestOptions = options;
  return client.post<ExternalResourceResponse>(requestPath, data, requestOptions);
}
